import type { RouteRecordRaw } from "vue-router"
import { useApplicationStore } from "@versatile-credit-apply/sdk"

export const GenesisDecisionRoutes: RouteRecordRaw[] = [
  {
    name: "genesis-error",
    path: "error",
    component: () => import("./pages/decision/GenesisErrorPage.vue"),
    meta: {
      step: "decision",
    },
  },
  {
    name: "genesis-apply-preapproved",
    path: "preapproved",
    component: () => import("./pages/decision/GenesisPreapprovedPage.vue"),
    meta: {
      step: "reviewOffer",
      next: "../terms",
    },
  },
  {
    name: "genesis-apply-prequalified",
    path: "prequalified",
    component: () => import("./pages/decision/GenesisPrequalifiedPage.vue"),
    meta: {
      step: "reviewOffer",
      next: "../terms",
    },
  },
  {
    name: "genesis-apply-approved",
    path: "approved",
    component: () => import("./pages/decision/GenesisApprovedPage.vue"),
    meta: {
      step: "decision",
    },
  },
  {
    name: "genesis-apply-nooffer",
    path: "nooffer",
    component: () => import("./pages/decision/GenesisNoOfferPage.vue"),
    meta: {
      step: "decision",
    },
  },
  {
    name: "genesis-apply-pending",
    path: "pending",
    component: () => import("./pages/decision/GenesisPendingPage.vue"),
    meta: {
      step: "decision",
    },
  },
  {
    name: "genesis-apply-declined",
    path: "declined",
    component: () => import("./pages/decision/GenesisDeclinedPage.vue"),
    meta: {
      step: "decision",
    },
  },
]

export const GenesisApplyRoutes: RouteRecordRaw[] = [
  {
    name: "genesis-apply-routes",
    path: "genesis_standard",
    children: [
      {
        name: "genesis-start",
        path: "start/:mode",
        component: () => import("./pages/GenesisIntroPage.vue"),
        beforeEnter: (_, __, next) => {
          const store = useApplicationStore()

          if (store.applyMode === "full") {
            return next()
          }

          return next({ path: "../submit" })
        },
      },
      {
        name: "genesis-terms",
        path: "terms",
        component: () => import("./pages/GenesisTermsAndConditionsPage.vue"),
        meta: {
          next() {
            const store = useApplicationStore()
            return store.applyMode !== "full" ? "accept-offer" : "submit"
          },
          step: "terms",
        },
      },
      {
        name: "genesis-apply-decisions",
        path: "decision",
        component: () => import("./pages/GenesisDecisionPage.vue"),
        meta: {
          preventBack: true,
          step: "decision",
        },
        children: [...GenesisDecisionRoutes],
      },
    ],
  },
]
